import axios from '../../axios.js'

export default {
  fetchRecords({ commit }, payload) {
    // load email logs
    return new Promise((resolve, reject) => {
      axios
        .get('/email-logs', {
          params: payload,
        })
        .then((response) => {
          commit('SET_EMAILLOGS', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchRecord(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/email-logs/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
